/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React from "react";
import { areaQueryWithSeoString_area } from "util/seo/types/areaQueryWithSeoString";
import { areaQueryWithCmsContent_area_Neighborhood } from "types/pages/office-space/m/areaQueryWithCmsContent";
import { publicListingNiceSearch_publicListingNiceSearch_listings_nodes } from "components/ClientSearch/Listings/types/publicListingNiceSearch";
import { defaultValues, keysAreDefault, update } from ".";

type Values = {
  groupByBuilding: boolean;
  maxDaysOld: number;
  numEmployees: string;
  neighborhoods: areaQueryWithCmsContent_area_Neighborhood[];
  signUpType: string;
  minMonthlyPrice: number;
  maxMonthlyPrice: number;
  minSqft: number;
  maxSqft: number;
  minOccupancy: number;
  maxOccupancy: number;
  minPricePerSquareFoot: number;
  maxPricePerSquareFoot: number;
  phoneRequired: boolean;
  leaseTermMin: number | null;
  leaseTermMax: number | null;
  leaseTypes: string[] | null;
  submarkets: areaQueryWithSeoString_area[];
  area: string;
  market: { externalId: string; seoString?: string; name: string };
  limit: number;
  page: number;
  count: number;
  listings: publicListingNiceSearch_publicListingNiceSearch_listings_nodes[];
  activePriceFilter: string;
  activeSizeFilter: string;
  promo: string | null;
};

type Context = {
  values: Values;
  update: Function;
  keysAreDefault: Function;
  defaultValues: Values;
  getSearchFromActiveRequirements: Function;
};

const context: Context = {
  values: defaultValues,
  update,
  keysAreDefault,
  defaultValues,
  getSearchFromActiveRequirements: () => {},
};

export default React.createContext(context);
